import { useAuth0 } from "@auth0/auth0-react";
import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

const ENFORCE = (import.meta.env.VITE_AUTH0_ENFORCE ?? "true") !== "false";

interface Props {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Props) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    if (!ENFORCE) return;
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: location.pathname + location.search },
      });
    }
    // ENFORCE is a module-level constant read from import.meta.env, so it is
    // deliberately not a dependency — it cannot change between renders.
  }, [isLoading, isAuthenticated, loginWithRedirect, location]);

  if (!ENFORCE) return <>{children}</>;

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-warmgray-400">
        <span className="smallcaps">Authenticating</span>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to="/login" state={{ from: location }} replace />;

  return <>{children}</>;
}
